import actions from "./actions";
import {setErrorReducer, setRequestReducer, setSuccessReducer} from "../helper";

const initState = {

    auditReadAllState: false,
    audits: [],
    pagination: {},

    auditReadState: false,
    audit: {},
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.AUDIT_READ_ALL_REQUEST:
            return setRequestReducer(state, 'auditReadAllState');
        case actions.AUDIT_READ_ALL_SUCCESS:
            return setSuccessReducer(state, 'auditReadAllState', {
                audits: action.audits,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });

        case actions.AUDIT_READ_REQUEST:
            return setRequestReducer(state, 'auditReadState');
        case actions.AUDIT_READ_SUCCESS:
            return setSuccessReducer(state, 'auditReadState', {
                audit: action.audit,
            });
        case actions.AUDIT_READ_ERROR:
            return setErrorReducer(state, 'auditReadState');
        case actions.AUDIT_RESET_AUDIT:
            return {
                ...state,
                audit: {},
                auditReadState: false,
            };
        case actions.AUDIT_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
